package com.esoris.kmpmoout.navigation

import com.esoris.kmpmoout.features.expense.expense_form.ExpenseFormRoute
import com.esoris.kmpmoout.features.product.ProductRoute
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

class NavManager(
    startDestination: AppRoute = ExpenseFormRoute()
) {

    private val _backStack = MutableStateFlow<List<AppRoute>>(
        listOf(startDestination)
    )
    val backStack = _backStack.asStateFlow()

    val currentAppRoute: AppRoute
        get() = _backStack.value.last()

    fun navigate(AppRoute: AppRoute) {
        _backStack.update {
            it + AppRoute
        }
    }

    fun replace(AppRoute: AppRoute) {
        _backStack.update {
            it.dropLast(1) + AppRoute
        }
    }

    fun popUpTo(
        AppRoute: AppRoute,
        inclusive: Boolean = false
    ) {
        _backStack.update { stack ->

            val index = stack.indexOfFirst {
                it::class == AppRoute::class
            }

            if (index == -1) return@update stack

            if (inclusive) {
                stack.take(index)
            } else {
                stack.take(index + 1)
            }
        }
    }

    fun back() {

        if (_backStack.value.size <= 1) {
            return
        }

        _backStack.update {
            it.dropLast(1)
        }
    }

    fun clearAndNavigate(AppRoute: AppRoute) {
        _backStack.value = listOf(AppRoute)
    }
}